export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_04.fc60f9e2.jpg";